// import { asyncRoutes } from '@/router'
import staticRouters from '@/router/static-routers'
import businessRouters from '@/router/business-routers'
import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const loadView = path => {
	const folderName = path.split('/')[0]
	const folderPath = path.replace(folderName + '/', '')
	// return require.ensure([], () => require(`@/leniuview/${path}`), folderName)
	switch (folderName) {
		case 'accountCenter':
			return require.ensure([], () => require(`@/leniuview/accountCenter/${folderPath}`), 'accountCenter')
		case 'alipayManage':
			return require.ensure([], () => require(`@/leniuview/alipayManage/${folderPath}`), 'alipayManage')
		case 'attendance':
			return require.ensure([], () => require(`@/leniuview/attendance/${folderPath}`), 'attendance')
		case 'basesetting':
			return require.ensure([], () => require(`@/leniuview/basesetting/${folderPath}`), 'basesetting')
		case 'Business':
			return require.ensure([], () => require(`@/leniuview/Business/${folderPath}`), 'Business')
		case 'canteenBackcourt':
			return require.ensure([], () => require(`@/leniuview/canteenBackcourt/${folderPath}`), 'canteenBackcourt')
		case 'dashboard':
			return require.ensure([], () => require(`@/leniuview/dashboard/${folderPath}`), 'dashboard')
		case 'dataHunter':
			return require.ensure([], () => require(`@/leniuview/dataHunter/${folderPath}`), 'dataHunter')
		case 'dataHunter_merchant':
			return require.ensure([], () => require(`@/leniuview/dataHunter_merchant/${folderPath}`), 'dataHunter_merchant')
		case 'doorControl':
			return require.ensure([], () => require(`@/leniuview/doorControl/${folderPath}`), 'doorControl')
		case 'dormitory':
			return require.ensure([], () => require(`@/leniuview/dormitory/${folderPath}`), 'dormitory')
		case 'error':
			return require.ensure([], () => require(`@/leniuview/error/${folderPath}`), 'error')
		case 'healthCenter':
			return require.ensure([], () => require(`@/leniuview/healthCenter/${folderPath}`), 'healthCenter')
		case 'login':
			return require.ensure([], () => require(`@/leniuview/login/${folderPath}`), 'login')
		case 'marketing':
			return require.ensure([], () => require(`@/leniuview/marketing/${folderPath}`), 'marketing')
		case 'menudish':
			return require.ensure([], () => require(`@/leniuview/menudish/${folderPath}`), 'menudish')
		case 'mobile':
			return require.ensure([], () => require(`@/leniuview/mobile/${folderPath}`), 'mobile')
		case 'notice':
			return require.ensure([], () => require(`@/leniuview/notice/${folderPath}`), 'notice')
		case 'noticeV2':
			return require.ensure([], () => require(`@/leniuview/noticeV2/${folderPath}`), 'noticeV2')
		case 'open':
			return require.ensure([], () => require(`@/leniuview/open/${folderPath}`), 'open')
		case 'orderCenter':
			return require.ensure([], () => require(`@/leniuview/orderCenter/${folderPath}`), 'orderCenter')
		case 'personal':
			return require.ensure([], () => require(`@/leniuview/personal/${folderPath}`), 'personal')
		case 'pictureExamine':
			return require.ensure([], () => require(`@/leniuview/pictureExamine/${folderPath}`), 'pictureExamine')
		case 'purchase':
			return require.ensure([], () => require(`@/leniuview/purchase/${folderPath}`), 'purchase')
		case 'reportCenter':
			return require.ensure([], () => require(`@/leniuview/reportCenter/${folderPath}`), 'reportCenter')
		case 'stock':
			return require.ensure([], () => require(`@/leniuview/stock/${folderPath}`), 'stock')
		case 'superstore':
			return require.ensure([], () => require(`@/leniuview/superstore/${folderPath}`), 'superstore')
		case 'deviceMange':
			return require.ensure([], () => require(`@/leniuview/deviceMange/${folderPath}`), 'deviceMange')
		case 'approvalManage':
			return require.ensure([], () => require(`@/leniuview/approvalManage/${folderPath}`), 'approvalManage')
		case 'supplierManage':
			return require.ensure([], () => require(`@/leniuview/supplierManage/${folderPath}`), 'supplierManage')
		case 'healthCenterV2':
			return require.ensure([], () => require(`@/leniuview/healthCenterV2/${folderPath}`), 'healthCenterV2')
		default:
			return ''
	}
}

const getAsyncRouters = (menus = []) => {
	const arr = []
	menus.forEach(item => {
		const { name, parentId, type, menuCode, ifCache, ifVisible, children } = item
		if (type == 1) return	// 按钮
		let component
		if (type == 2) {	// 目录
			if (parentId == -1) component = Layout
			else component = LayoutView
		} else if (type == 0) {	// 菜单
			component = () => loadView(item.component)
		}
		const route = {
			path: menuCode || '',
			component,
			meta: {
				title: name,
				noCache: ifCache == 2
			},
			hidden: ifVisible == 2
		}
		if (children && children.length) {
			route.children = getAsyncRouters(children)
		}
		arr.push(route)
	})
	return arr
}

const state = {
	routes: [],
	addRoutes: []
}

const mutations = {
	SET_ROUTES: (state, routes) => {
		state.addRoutes = routes
		state.routes = staticRouters.concat(routes)
	}
}

const actions = {
	generateRoutes ({ rootState, state, commit }, roles) {
		const { user } = rootState
		return new Promise(resolve => {
			let accessedRoutes
			if (user.userInfo && user.userInfo.userId == '0') {
				// admin
				accessedRoutes = [businessRouters]
			} else {
				// accessedRoutes = asyncRoutes
				accessedRoutes = getAsyncRouters(user.menuTree)
			}
			console.log('accessedRoutes', accessedRoutes)
			commit('SET_ROUTES', accessedRoutes)
			resolve(accessedRoutes)
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
